import { useQuery } from '@tanstack/react-query';
import { AdvancedFilterPanel } from '@/components/common/AdvancedFilter';
import { departmentListQueryOptions } from '@/features/organization/api/organization.api';
import { useGeoCascade } from '@/hooks/useGeoCascade';
import { getFilterPanelProps, type UrlSyncedFilters } from '@/hooks/useUrlSyncedFilters';
import {
  getDateFromToFilterFields,
  getDepartmentFilterField,
  getGeoFilterFields,
} from '@/utils/filterFields';
import { FILTER_KEYS, parseNumberFilter } from '@/utils/filters';

interface LeaveReportFilterPanelProps {
  filters: UrlSyncedFilters;
}

export function LeaveReportFilterPanel({ filters }: LeaveReportFilterPanelProps) {
  const { filterValues } = filters;

  const { data: departments } = useQuery(departmentListQueryOptions());
  const geoOptions = useGeoCascade({
    divisionId: parseNumberFilter(filterValues[FILTER_KEYS.divisionId]),
    districtId: parseNumberFilter(filterValues[FILTER_KEYS.districtId]),
  });

  return (
    <AdvancedFilterPanel
      fields={[
        ...getDateFromToFilterFields(),
        ...getGeoFilterFields(filterValues, geoOptions),
        getDepartmentFilterField(departments),
      ]}
      {...getFilterPanelProps(filters)}
    />
  );
}
